import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from "@angular/common/http";
import {Observable} from "rxjs";
import {tap} from "rxjs/operators";
import {Injectable} from "@angular/core";
import {Session} from "../../services/session.service";
import {LoadingService} from "../../services/loading.service";
import {ErrorMessageService} from "../../services/error-message.service";
import {Router} from "@angular/router";
import {HttpError} from "./error-interceptor";
import { environment } from "../../../environments/environment";

@Injectable()
export class AuthInterceptor implements HttpInterceptor{

  constructor(private session: Session,
              private loadingService: LoadingService,
              private errorMessageService: ErrorMessageService,
              private router: Router,
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe( tap(() => {},
      (err: any) => {
      // ErrorInterceptor wraps HttpErrorResponse in HttpError downstream of us;
      // accept either so 401/402/403 handling survives the wrap.
      const status = (err instanceof HttpErrorResponse || err instanceof HttpError) ? err.status : null;
      if (status === null) return;
      if(status !== 401 && status !== 403 && status !== 402){
        return;
      }
      this.loadingService.resetAll();
      if(status === 403){
        // NestJS (apiV2) requests handle 403 at the component level — skip global modal.
        if (req.url.startsWith(environment.apiV2)) return;
       // this.router.navigate(["/home"]);
        this.errorMessageService.showErrorModal("Not Authorized", ["You are not authorized to access this page. Please contact support if you believe this is an error."]);
        return;
      }
      else if(status === 402){
        // NestJS (apiV2) requests handle 402 at the component level — skip the
        // global modal, exactly as 403 above does.
        //
        // 🔴 Why this matters more than consistency (WEA-1070). WEA-1060's
        // entitlement guard sends a specific `reason` (trial_expired /
        // past_due / canceled) and copy written for the customer — "Your free
        // trial has ended. Subscribe to continue." vs "Your last payment did
        // not go through. Update your card to continue." Those need different
        // actions from the user. The global handler discarded all of it, showed
        // one generic sentence, and NAVIGATED AWAY from whatever the admin was
        // doing. It is also a modal, where the house style is inline errors.
        //
        // Components render the thrown message inline (add-team-member.ts:165)
        // — but only since ApiV2Service.errorHandle was fixed to UNWRAP
        // HttpError. Before that it read a field the wrapper does not carry, so
        // every server message collapsed to "Error Code: 402 / HTTP 402 POST
        // <api url>". Stopping the global handler without that fix would have
        // replaced a generic-but-coherent modal with a raw diagnostic; the two
        // changes only work together.
        //
        // Legacy .NET 402s keep the old behaviour: nothing else knows how to
        // handle them, and Contensive's 402 carries no reason to render.
        if (req.url.startsWith(environment.apiV2)) return;
        this.router.navigate(["/account"]);
        this.errorMessageService.showErrorModal("Payment Required", ["You must pay your subscription fee before you can access this page."]);
        return;
      }
      // 401. The session is over: log out and redirect. The request that
      // failed also rejects in whatever component issued it, and most of them
      // answer a rejection by opening the global error modal — so without this
      // the user gets an error popup about a request that failed only because
      // they were already being signed out. Suppressed centrally rather than
      // per caller; `Session.create()` lifts it on the next sign-in.
      this.errorMessageService.suppressForEndedSession();
      this.session.logout();
      }));
  }
}
